import React, {useRef, useEffect} from 'react';
import StreamPageUI from './StreamPageUI';
import { StreamProvider } from '../contexts/StreamContext';
import { useAuthRouting } from '../contexts/AuthRouteContext';
import { useNavigate } from 'react-router-dom';

const Stream = () => {
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const { requireAuth } = useAuthRouting();
  
  useEffect(() => {
    // requireAuth(() => {}, () => navigate('/login'));
  }, [requireAuth, navigate]);
  
  return (
    <StreamProvider videoRef={videoRef}>
      <StreamPageUI videoRef={videoRef}/>
    </StreamProvider>
  );
};

export default Stream;